type Props = {
  rows: number;
  id: string;
  register: any;
  defaultValue?: string | undefined;
  placeHolder?: string;
  additionalClasses?: string;
  isDisabled?: boolean;
};

function TextArea({ rows, id, defaultValue, register, placeHolder, additionalClasses, isDisabled }: Props) {
  return (
    <textarea
      rows={rows}
      name={id}
      id={id}
      placeholder={placeHolder}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...register(id)}
      className={`block w-full rounded-ll border border-white bg-transparent p-4 font-satoshi font-450 text-white placeholder:text-white
      placeholder:opacity-70 focus:border-white  focus:outline-none focus:ring-gray-200 disabled:bg-white disabled:bg-opacity-50 sm:text-xs 
      ${additionalClasses}`}
      defaultValue={defaultValue}
      disabled={isDisabled}
    />
  );
}

export default TextArea;

TextArea.defaultProps = {
  defaultValue: undefined,
  placeHolder: "",
  additionalClasses: "",
};
